import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '@components/join/join.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface IAgreeMarketingListItem {
  name: string;
  title: string;
  isRequired: boolean;
}

const AgreeMarketingListItem = (props: IAgreeMarketingListItem) => {
  const { register } = useFormContext();

  return (
    <li className={cx('secondListItem')}>
      <div className={cx('labelWrap')}>
        <label className={cx('label')}>
          <input
            {...register(props.name, { required: props.isRequired })}
            type="checkbox"
            className={cx('input', 'hidden')}
          />
          <span className={cx('checkbox')} />
          {props.title}
        </label>
      </div>
    </li>
  );
};

export default AgreeMarketingListItem;
